import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Creators as procedureActions } from '@/domain/useCases/procedures/getProcedureInformation';
import { Creators as cancelRequestActions } from '../../../../../../../domain/useCases/procedures/UpdatePhoto/cancelUseCase';
import { Creators as activatePaymentActions } from '../../../../../../../domain/useCases/procedures/certificateType01/activatePaymentUseCase';
import { Creators as snackbarActions } from '../../../../../../../domain/useCases/snackbarUseCase';
import { downloadCertificate } from '../../../certificates-constancies/type1/progress/CertificateType01ProgressViewController';
import { Creators as downloadDocumentActions } from '@/domain/useCases/procedures/certificateType01/downloadDocumentUseCase';
import { evalStatus } from './utils';
import GraduatedCertificatedProgressView from './GraduatedCertificatedProgressView';
import routes from '@/presentation/components/Routes/routingMap';
import useSnackbarFields from '../../../scholarships/bse/hooks/useSnackbarFields';

const GraduatedCertificatedProgressViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { validateCommon, Types } = useSnackbarFields();
  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [showModalAnuledPayment, setShowModalAnuledPayment] = useState(false);

  const { base64File } = useSelector((state: any) => state.downloadDocument);

  const {
    request,
    procedure,
    isLoading: isLoadingStatus,
    isComplete
  } = useSelector((state: any) => state.procedureStudentStatus);
  const academic = useSelector((state: any) => state.profile.data);

  const { procedure: procedureSelectedInfo, isLoading: isLoadingDetail } =
    useSelector((state: any) => state.procedureInformation);

  const {
    isLoading: isLoadingActivatePayment,
    isSuccess: isSuccessActivatePayment
  } = useSelector((state: any) => state.activatePaymentCertificateType01);

  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelUpdatePhoto);

  const handlerDownload = async () => {
    downloadCertificate(base64File, request.name);
  };

  useEffect(() => {
    if (request?.document) {
      dispatch(downloadDocumentActions.downloadFile(request.document));
      validateCommon(
        Types.success,
        '¡Listo!',
        'Tu archivo está siendo descargado'
      );
      dispatch(snackbarActions.toggleSnackbarOpen());
      dispatch(downloadDocumentActions.downloadFileClear());
    }
    return () => {
      dispatch(downloadDocumentActions.downloadFileClear());
    };
  }, [request?.document]);

  useEffect(() => {
    if (!procedureSelectedInfo)
      dispatch(procedureActions.getProcedureInformation(1040, 'EGRE'));
  }, []);

  useEffect(() => {
    if (request) {
      const { requiresPayment, payed } = request;
      setIsPaymentActive(
        requiresPayment &&
          evalStatus(request)?.name === 'PAGO_ACTIVADO' &&
          !payed
      );
      setIsPaymentDone(requiresPayment && payed);
    }
  }, [request]);

  useEffect(() => {
    if (isSuccessCancel) {
      history.push(routes.student.procedures.home);
    }
  }, [isSuccessCancel]);

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  const goToPayment = () => {
    history.push('/pagos');
  };

  const handlerCancelProcedure = () => {
    dispatch(cancelRequestActions.cancelUpdatePhoto(request.id, 1040));
  };

  const handlerActivatePayment = () => {
    dispatch(
      activatePaymentActions.activateCertificateOfStudies(
        request.procedureId,
        request.id
      )
    );
  };

  const CloseModal = () => {
    setShowModalPayment(false);
    dispatch(activatePaymentActions.activateCertificateOfStudiesClear());
  };

  return (
    <GraduatedCertificatedProgressView
      handlerBackButton={handlerBackButton}
      procedure={procedure}
      isComplete={isComplete}
      academic={academic}
      request={request}
      isLoadingStatus={isLoadingStatus}
      isLoadingDetail={isLoadingDetail}
      handlerCancelProcedure={handlerCancelProcedure}
      handlerActivatePayment={handlerActivatePayment}
      payment={{
        showModalPayment,
        setShowModalPayment
      }}
      anulatedPayment={{
        showModalAnuledPayment,
        setShowModalAnuledPayment
      }}
      isLoadingCancel={isLoadingCancel}
      isLoadingActivatePayment={isLoadingActivatePayment}
      isSuccessActivatePayment={isSuccessActivatePayment}
      isPaymentDone={isPaymentDone}
      isPaymentActive={isPaymentActive}
      handlerDownload={handlerDownload}
      CloseModal={CloseModal}
      goToPayment={goToPayment}
    />
  );
};

export default GraduatedCertificatedProgressViewController;
